// UI navigation only. Core/addon/media network requests do not use this policy.
const isStremioExternalUrl = (value) => {
    if (typeof value !== 'string') return false;
    try {
        const url = new URL(value, 'https://caroline.invalid');
        const hostname = url.hostname.toLowerCase().replace(/\.$/, '');
        const domains = ['stremio.com', 'stremio.io', 'strem.io', 'stremio.zendesk.com'];
        return domains.some((domain) => hostname === domain || hostname.endsWith(`.${domain}`)) ||
            (hostname === 'github.com' && /^\/stremio(?:\/|$)/i.test(decodeURIComponent(url.pathname)));
    } catch (_) {
        return false;
    }
};

const externalDestination = (value) => {
    if (isStremioExternalUrl(value)) return null;
    try {
        const url = new URL(value);
        return ['https:', 'http:'].includes(url.protocol) ? url.href : null;
    } catch (_) {
        return null;
    }
};

module.exports = { isStremioExternalUrl, externalDestination };
